<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" v-hasPermi="['fina:invoice:list']" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item,index) in list" :key="index" @click="toFinaInvoiceDetails(item)">
        <div class="flex-between" v-if="item">
          <div>
            <div class="custName-wrap">
              <div class="custName">
                {{ item.custName }}
              </div>
            </div>
            <div>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.invoiceType">{{ invoiceTypeFormat2(item.invoiceType) }}</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.taxNum">{{ item.taxNum }}</van-tag>
            </div>
            <div>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.mobile">{{ item.mobile }}</van-tag>
            </div>
          </div>
          <van-icon name="arrow" size="16" class="arrow-color" @click="toFinaInvoiceDetails(item)" />
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
    <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
  </div>
</template>

<script>
import moment from "moment";
import {
  Search,
  List,
  Cell,
  Button,
  Tag,
  Dialog,
  Area,
  Toast,
  Icon,
  Field,
  Col,
  Row,
  CellGroup,
  Popup,
  Picker,
  Radio,
  RadioGroup,
} from "vant";
import {
  listInvoice,
  getInvoice,
  delInvoice,
  addInvoice,
  updateInvoice,
  exportInvoice,
} from "@/api/fina/invoice";
import { getDicts } from "@/api/system/dict/data";
import { selectAllCustLevel } from "@/api/scrm/custlevel";
import { areaList } from "@vant/area-data";
import SearchComponent from "@/components/common/Search";
import EmptyComponent from "@/components/common/Empty";
import SearchPop from '../components/VoiceSearchPop.vue'
import TotalComponent from "@/components/common/Total";
export default {
  components: {
    [Search.name]: Search,
    [List.name]: List,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    SearchComponent,
    EmptyComponent,
    SearchPop,
    TotalComponent
  },
  filters: {
    timeFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      total: null,
      isEmpty: false,
      picker: {
        visible: false,
        title: "",
        columns: [],
        formKey: "",
        areaList,
      },
      loading: false,
      finished: false,
      showFilterPop: false,
      list: [],
      type: "add",
      show: false,
      searchParams: {
        visible: false,
      },
      searchValue: "",
      invoiceList: [],
      // 发票类型
      invoiceTypeOptions: [],
      // 发票状态
      invoiceStatusOptions: [],
      // 状态数据字典
      // statusOptions: this.$store.state.dictOptions.status || [],
      form: {
        invoiceId: null,
        contractId: null,
        contractName: null,
        invoiceTitle: null,
        invoiceType: null,
        invoiceNum: null,
        custId: null,
        custName: null,
        taxNum: null,
        bankName: null,
        accountNum: null,
        postalCode: null,
        email: null,
        mobile: null,
        address: null,
        invoiceStatus: "0",
        userId: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      //修改主体框架标题
      document.title = "FINA-发票信息";
      //发票类型
      this.getDicts("accinvoice_invoice_type").then((response) => {
        this.invoiceTypeOptions = response.data; // string
      });
      //发票状态
      this.getDicts("accinvoice_invoice_status").then((response) => {
        this.invoiceStatusOptions = response.data; // string
      });
      //状态字段
      // getDicts("sys_normal_disable").then((response) => {
      //   this.statusOptions = response.data;
      // });
      await this.handleList();
    },
    toFinaInvoiceDetails(item) {
      this.$router.push(`/invoiceDetail/${item.invoiceId}`);
    },
    //发票类型字典翻译
    invoiceTypeFormat2(invoiceType) {
      return this.selectDictLabel(this.invoiceTypeOptions, invoiceType);
    },
    invoiceTypeFormat(row, column) {
      return this.selectDictLabel(this.invoiceTypeOptions, row.invoiceType);
    },
    //发票类型字典翻译
    invoiceStatusFormat2(invoiceStatus) {
      return this.selectDictLabel(this.invoiceStatusOptions, invoiceStatus);
    },
    invoiceStatusFormat(row, column) {
      return this.selectDictLabel(this.invoiceStatusOptions, row.invoiceStatus);
    },
    showPicker(type) {
      this.picker.formKey = type;
      if (type === "custLevelId") {
        this.picker.columns = this.custLevelOptions.map((ele) => ele.levelName);
      }
      if (type === "custSource") {
        this.picker.columns = this.custSourceOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "custType") {
        this.picker.columns = this.custTypeOptions.map((ele) => ele.dictLabel);
      }
      if (type === "industryCode") {
        this.picker.columns = this.industryOptions.map((ele) =>
          this.industryNormalizer(ele)
        );
      }
      if (type === "areaId") {
        this.picker.columns = this.areaOptions.map((ele) =>
          this.areaNormalizer(ele)
        );
      }
      this.picker.visible = true;
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === "custLevelId") {
        this.form.custLevelId = this.custLevelOptions[index].custLevelId;
        this.form.custLevelName = this.custLevelOptions[index].levelName;
      }
      if (this.picker.formKey === "custSource") {
        this.form.custSource = this.custSourceOptions[index].dictValue;
        this.form.custSourceName = this.custSourceOptions[index].dictLabel;
      }
      this.picker.visible = false;
    },
    /** 转换行业数据结构 */
    industryNormalizer(node) {
      let arr = [];
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].systemIndustryId,
            text: node.children[i].industryName,
          };
          arr.push(item);
        }
      }

      return {
        id: node.systemIndustryId,
        text: node.industryName,
        children: arr,
      };
    },

    /** 转换地区数据结构 */
    areaNormalizer(node) {
      let arr = [];
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].areaId,
            text: node.children[i].areaName,
          };
          arr.push(item);
        }
      }

      return {
        id: node.areaId,
        text: node.areaName,
        children: arr,
      };
    },
    pickerCancel() {
      this.picker.visible = false;
    },
    pickerChange() { },
    update(type, row) {
      this.reset();
      this.type = type;
      this.show = true;
      if (row) {
      }
    },
    confirm() {
      let api = this.type !== "add" ? updateInvoice : addInvoice,
        msg = this.type !== "add" ? '修改成功' : '新增成功';
      api(this.form).then((response) => {
        Toast(msg);
        this.dialogVisible = false;
        this.handleList();
      });
    },
    queryInvoiceList() {
      this.list = [];
      this.queryParams.pageNum = 1
      this.handleList();
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      console.log('handelSearch', data);
      this.resetQuery()
      this.queryParams.custName = this.searchValue = data;
      this.queryInvoiceList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      console.log('handleFqueryFilter', data);
      let query = this.queryParams;
      this.queryParams = { ...query, ...data }
      this.queryInvoiceList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    async handleList() {
      this.list = [];
      this.loading = true;
      const res = await listInvoice(this.queryParams);
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        }
        this.total = res.total;
        this.list = this.list.concat(res.rows);
        this.queryParams.pageNum += 1;
        this.loading = false;
        this.finished = this.list.length >= res.total;
        this.showFilterPop = false
      }
    },
    onLoad() {
      this.handleList();
    },
    //获取用户等级
    getCustLevelList() {
      selectAllCustLevel(null).then((response) => {
        this.custLevelOptions = response.data;
      });
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: null,
        contractStatus: null,
        payMode: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        status: null,
      };
    },
    reset() {
      this.form = {
        invoiceId: null,
        contractId: null,
        contractName: null,
        invoiceTitle: null,
        invoiceType: null,
        invoiceNum: null,
        custId: null,
        custName: null,
        taxNum: null,
        bankName: null,
        accountNum: null,
        postalCode: null,
        email: null,
        mobile: null,
        address: null,
        invoiceStatus: "0",
        userId: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      };
    },
  },
};
</script>